/**
 * album api
 */
import {$axios} from './apiConfig.js';
import {
	API_AI
} from '../config/const';



/**
 * 获取邮册信息  翻转
 */
export const apiMyPages = (options, callback) => {
    return $axios.get('/pages/myPages', options ? options : {});
};


/**
 * 获取某某系列邮票   邮册详情—单票列表
 */

export const apiAlbumSeries = (options = {}) => {
  return $axios({
    url:'/pages/' + options.id
  })
};




/**
 * 邮册最新 最热
 */
export const apiImgNewHot = (options = {}) => {
  return $axios({
    type:'get',
    url: '/pages/rank',
    params:options.params
  });
};



/*
 *  邮册 点赞
 * */

export const apiThumbUp = (options = {}) => {
  return $axios({
    type:'get',
    url:'/shares/likes/' + options.id,
  });
};


/*
 *  邮册 详情
 * */

export const apiStampsDetail = (options = {}) => {
  return $axios({
    type:'get',
    url:'/pages/' + options.id,
  });
};



// WEBPACK FOOTER //
// ./src/api/stamps.js